export { default } from 'jsonwebtoken/verify'
